module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "链接"
    }
  }, [_c('el-input', {
    staticClass: "url",
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.form.url = $$v
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticClass: "name",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分组"
    }
  }, [_c('el-autocomplete', {
    staticClass: "group",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.form.group),
      callback: function($$v) {
        _vm.form.group = $$v
      },
      expression: "form.group"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请求类型"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "GET"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "POST"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "DELETE"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "PUT"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "可以多选",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返回类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.dataType),
      callback: function($$v) {
        _vm.form.dataType = $$v
      },
      expression: "form.dataType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "json",
      "value": "json"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "jsonp",
      "value": "jsonp"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "text",
      "value": "text"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "设置接口的Content-Type",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返回值"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "javascript-editor"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文档"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "javascript-editor2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.form.docs)
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("创建")]), _vm._v(" "), _c('el-button', [_vm._v("预览")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4ba04ce0!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/data.vue
// module id = 94
// module chunks = 1